import { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
import HelpIcon from '@mui/icons-material/Help';
import Primarytheme from '../utility/theme';
import { fetchPimResource } from './PimProxyModule';

export default function AkeneoFamilyPicker({ conf, setConf, groupKey, i }) {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            const items = await fetchPimResource(setError, conf.project_id, 'akeneo', 'families');
            if (items) setOptions(items);
            setLoading(false);
        };
        load();
    }, []);

    const handleChange = (_, newValue) => {
        const newConf = { ...conf };
        newConf.integrationsOptions[groupKey][i].value = newValue;
        setConf(newConf);
    };

    const current = conf.integrationsOptions[groupKey][i].value;
    const value = Array.isArray(current) ? current : (current ? [current] : []);

    return (
        <Stack sx={{ mb: '1em', mt: '2em' }}>
            {error && <Alert severity="error" variant="outlined" sx={{ mb: 1 }}>{error}</Alert>}
            <Stack direction="row" alignItems="flex-start">
                <Autocomplete
                    multiple
                    id="akeneo-family-picker"
                    size="small"
                    options={options}
                    getOptionLabel={(o) => o.label || o.code || ''}
                    isOptionEqualToValue={(o, v) => o.code === v.code}
                    value={value}
                    onChange={handleChange}
                    loading={loading}
                    disabled={!!error}
                    noOptionsText="No families available"
                    disableCloseOnSelect
                    sx={{ maxWidth: 400, flexGrow: 1 }}
                    renderTags={(val, getTagProps) =>
                        val.map((option, index) => {
                            const { key, ...tagProps } = getTagProps({ index });
                            return <Chip key={key} label={option.label || option.code} size="small" {...tagProps} />;
                        })
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={conf.integrationsOptions[groupKey][i].nome || 'Family'}
                            error={!!error}
                            slotProps={{
                                input: {
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading && <CircularProgress color="inherit" size={20} />}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                },
                            }}
                        />
                    )}
                />
                <Tooltip title={<Typography variant="caption">{conf.integrationsOptions[groupKey][i].descrizione}</Typography>}>
                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', mt: '0.5em', color: Primarytheme.palette.neutral.main }} />
                </Tooltip>
            </Stack>
        </Stack>
    );
}
